import { Injectable } from '@angular/core';
import { CustomHttpService } from './custom-http.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WhatsappTemplateService {

  constructor(
    private http: CustomHttpService
  ) { }

  createWhatsappTemplate(body: any): Observable<any> {
    return this.http.post(environment.createWhatsappTemplate, body);
  }

  getAllGupshupTemplates(body: any): Observable<any> {
    return this.http.post(environment.getAllGupshupTemplates, body);
  }

  updateGupshupTemplate(body: any): Observable<any> {
    return this.http.post(environment.updateGupshupTemplate, body);
  }

  uploadFile(file: File, organization_id: any) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('organization_id', organization_id);
    const url = environment.uploadWhatsappTemplateFile;
    return this.http.post(url, formData);
  }

  refreshGupshupTemplates(body: any): Observable<any> {
    return this.http.post(environment.refreshGupshupTemplates, body);
  }

  deleteTemplate(data:any): Observable<any> {
    return this.http.post(environment.deleteWhatsappTemplate,data);
  }

}